import { useCallback } from 'react';
import { supabase } from '../lib/supabase';

export function usePosts({ onUpdate } = {}) {
  const updatePostStatus = useCallback(async (postId, newStatus) => {
    const { error } = await supabase
      .from('agency_posts')
      .update({ status: newStatus })
      .eq('id', postId);
    if (error) throw error;
    if (onUpdate) await onUpdate();
  }, [onUpdate]);

  return { updatePostStatus };
}
